import React, { useState } from 'react'
import PropTypes from 'prop-types'
import MEModal from '../../components/MEModal'
import { Form } from 'react-bootstrap'
import { Button } from '@CommonComponents/buttons'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { setExpirationDate as sendExpirationDate } from '../actions'

export const setExpirationItem = {
  id: 'set-expiration',
  label: 'Set Expiration Date',
  icon: 'fa-light fa-stopwatch',
}

export const SetExpirationModal = ({ section, show, close }) => {
  const [, dispatch] = useStateValue()
  const [expirationDate, setExpirationDate] = useState(
    new Date().toISOString().split('T')[0]
  )

  const handleSetExpirationDate = e => {
    setExpirationDate(e.target.value)
  }

  const submitExpirationDate = async () => {
    let data = {
      section_id: section,
      expiration_date: expirationDate,
    }
    let response = await sendExpirationDate(data, dispatch)
    close()
    if (response.status === 200) {
      toast.success('Successfully added a new expiration date for this section')
    } else {
      toast.error(response.message)
    }
  }

  return (
    <MEModal show={show} close={close} title="Set Section Expiration Date">
      <form onSubmit={e => e.preventDefault()}>
        <p>
          Select a date and time below. You can remove an expiration date by
          clicking submit without filling in the expiration field.
        </p>
        <Form.Group>
          <Form.Label>Expiration Date</Form.Label>
          <input
            className="form-control"
            type="date"
            placeholder="YYYY/MM/DD"
            value={expirationDate}
            onChange={handleSetExpirationDate}
          />
        </Form.Group>
        <Button
          className="me-btn me-btn-primary"
          type="button"
          onClick={submitExpirationDate}
        >
          Set expiration date
        </Button>
      </form>
    </MEModal>
  )
}

SetExpirationModal.propTypes = {
  section: PropTypes.string,
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
}
